import { render, staticRenderFns } from "./SaleReportInternationalSingapore.vue?vue&type=template&id=b0d63bee&scoped=true"
import script from "./SaleReportInternationalSingapore.vue?vue&type=script&lang=js"
export * from "./SaleReportInternationalSingapore.vue?vue&type=script&lang=js"
import style0 from "./SaleReportInternationalSingapore.vue?vue&type=style&index=0&id=b0d63bee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d63bee",
  null
  
)

export default component.exports